// extracted by mini-css-extract-plugin
export default {"SavedReplies":"SavedReplies-module__SavedReplies--uPmHj"};